<h1 mat-dialog-title class="ticket-header">
  <span class="company-name">Ticket</span>
  <span class="ticket-title">DETALLES DE VENTA</span>
</h1>

<div mat-dialog-content class="ticket-content">
  <div class="loading-overlay" *ngIf="isRegisteringVenta">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Registrando venta...</p>
  </div>
  <div class="venta-details" *ngIf="ventaDetalles">
    <div class="ticket-info">
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">No. Ticket:</span>
          <span class="info-value">{{ ventaDetalles.id | ticketNumber }}</span>
        </div>
        <div class="info-col">
          <span class="info-label">Fecha:</span>
          <span class="info-value">{{ ventaDetalles.createdAt | date:'medium' }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">Vendedor:</span>
          <span class="info-value">{{ ventaDetalles.usuario?.name }}</span>
        </div>
      <div class="info-col" style="display: flex; align-items: center; gap: 8px;">
        <span class="info-label">Estado:</span>
        <mat-chip [color]="getEstadoColor(ventaDetalles.estado)" selected class="status-chip" style="margin: 0;">
          {{ ventaDetalles.estado | titlecase }}
        </mat-chip>
      </div>
      </div>
    </div>

    <div class="divider-line"></div>

    <h3 class="products-title">PRODUCTOS</h3>
    <table mat-table [dataSource]="ventaDetalles.detalles" class="products-table">
      <ng-container matColumnDef="producto">
        <th mat-header-cell *matHeaderCellDef class="table-header">PRODUCTO</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell">
          {{ detalle.producto?.nombre }}
          <div class="product-details" *ngIf="detalle.producto">
            <small>Código: {{ detalle.producto.codigo }}</small>
            <small>Descripción: {{ detalle.producto.descripcion }}</small>
            <small>Proveedor: {{ detalle.producto.proveedorNombre || 'Sin proveedor' }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="cantidad">
        <th mat-header-cell *matHeaderCellDef class="table-header text-center">CANT.</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell text-center">{{ detalle.cantidad }}</td>
      </ng-container>

      <ng-container matColumnDef="precio">
        <th mat-header-cell *matHeaderCellDef class="table-header text-right">P. UNITARIO</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell text-right">{{ detalle.precioUnitario | currency }}</td>
      </ng-container>

      <ng-container matColumnDef="subtotal">
        <th mat-header-cell *matHeaderCellDef class="table-header text-right">SUBTOTAL</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell text-right">{{ detalle.subtotal | currency }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['producto', 'cantidad', 'precio', 'subtotal']" class="table-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: ['producto', 'cantidad', 'precio', 'subtotal'];" class="table-row"></tr>
    </table>

    <div class="divider-line dashed"></div>

    <div class="totals-section">
      <div class="total-row">
        <span class="total-label">Subtotal:</span>
        <span class="total-value">{{ ventaDetalles.total - ventaDetalles.impuesto | currency }}</span>
      </div>
      <div class="total-row">
        <span class="total-label">Impuesto:</span>
        <span class="total-value">{{ ventaDetalles.impuesto | currency }}</span>
      </div>
      <div class="total-row grand-total">
        <span class="total-label">TOTAL:</span>
        <span class="total-value">{{ ventaDetalles.total | currency }}</span>
      </div>
      <div class="payment-details">
        <div class="payment-row">
          <span class="payment-label">Recibido:</span>
          <span class="payment-value">{{ ventaDetalles.dineroRecibido | currency }}</span>
        </div>
        <div class="payment-row">
          <span class="payment-label">Cambio:</span>
          <span class="payment-value">{{ ventaDetalles.cambio | currency }}</span>
        </div>
      </div>
    </div>

    <!-- Sección de Abonos (solo para ventas pendientes) -->
    <div *ngIf="ventaDetalles.estado === 'pendiente'" class="abonos-section">
      <div class="divider-line"></div>
      
      <div class="abonos-header">
        <h3 class="abonos-title">HISTORIAL DE PAGOS</h3>
        <button 
          mat-raised-button 
          color="primary" 
          (click)="toggleFormularioAbono()"
          [disabled]="!puedeAgregarAbono() || isLoading"
          class="add-abono-button">
          <mat-icon>{{ mostrarFormularioAbono ? 'close' : 'add' }}</mat-icon>
          {{ mostrarFormularioAbono ? 'Cancelar' : 'Agregar Abono' }}
        </button>
      </div>

      <!-- Resumen de pagos -->
      <div class="payment-summary-abonos">
        <div class="summary-item">
          <span class="summary-label">Total de la Venta:</span>
          <span class="summary-value">{{ ventaDetalles.total | currency }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Total Pagado:</span>
          <span class="summary-value success">{{ totalPagado | currency }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Saldo Pendiente:</span>
          <span class="summary-value" [class.warning]="saldoPendiente > 0" [class.success]="saldoPendiente <= 0">
            {{ saldoPendiente | currency }}
          </span>
        </div>
      </div>

      <!-- Formulario para agregar abono -->
      <div *ngIf="mostrarFormularioAbono && puedeAgregarAbono()" class="abono-form-container">
        <form [formGroup]="abonoForm" (ngSubmit)="registrarAbono()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Monto del Abono</mat-label>
            <input matInput type="number" formControlName="monto" min="0.01" [max]="saldoPendiente" step="0.01">
            <span matPrefix>$&nbsp;</span>
            <mat-hint>Máximo: {{ saldoPendiente | currency }}</mat-hint>
            <mat-error *ngIf="abonoForm.get('monto')?.hasError('required')">
              El monto es requerido
            </mat-error>
            <mat-error *ngIf="abonoForm.get('monto')?.hasError('min')">
              El monto debe ser mayor a cero
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Método de Pago</mat-label>
            <mat-select formControlName="metodoPago">
              <mat-option *ngFor="let m of metodosPago" [value]="m">
                {{ metodoPagoLabels[m] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="abono-form-actions">
            <button mat-raised-button color="primary" type="submit" [disabled]="abonoForm.invalid || isLoading">
              <mat-icon>payment</mat-icon>
              Registrar Abono
            </button>
          </div>
        </form>
      </div>

      <!-- Lista de abonos -->
      <div class="abonos-list" *ngIf="pagos.length > 0">
        <table mat-table [dataSource]="pagos" class="abonos-table">
          <ng-container matColumnDef="fecha">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let pago">{{ pago.createdAt | date:'short' }}</td>
          </ng-container>

          <ng-container matColumnDef="metodoPago">
            <th mat-header-cell *matHeaderCellDef>Método</th>
            <td mat-cell *matCellDef="let pago">{{ metodoPagoLabels[pago.metodoPago] || pago.metodoPago || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="monto">
            <th mat-header-cell *matHeaderCellDef class="text-right">Monto</th>
            <td mat-cell *matCellDef="let pago" class="text-right">{{ pago.monto | currency }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['fecha', 'metodoPago', 'monto']" class="abonos-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: ['fecha', 'metodoPago', 'monto'];" class="abonos-row"></tr>
        </table>
      </div>

      <div *ngIf="pagos.length === 0 && !mostrarFormularioAbono" class="no-abonos">
        <mat-icon>info</mat-icon>
        <p>No hay pagos registrados aún</p>
      </div>
    </div>

    <div class="divider-line"></div>

    <div class="footer-message">
      <p>¡Gracias por su compra!</p>
      <p class="small-text">Para devoluciones, presente este ticket dentro de los 15 días</p>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end" class="ticket-actions">
  <button mat-button (click)="onCancel()" class="action-button" [disabled]="isRegisteringVenta">Cerrar</button>
  <div class="actions-group">
    <button mat-stroked-button color="primary" (click)="imprimirTicket()" class="action-button" [disabled]="isRegisteringVenta">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    <button mat-raised-button color="accent" (click)="exportarPdf()" class="action-button export-button" [disabled]="isRegisteringVenta">
      <mat-icon>picture_as_pdf</mat-icon> Exportar PDF
    </button>
  </div>
</div>
